import { getArea, getLength } from "ol/sphere";
import { LineString, Polygon } from "ol/geom";
import Draw from "ol/interaction/Draw";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { unByKey } from "ol/Observable";
import Overlay from "ol/Overlay";

let helpTooltipElement = null;
let helpTooltip = null;
let measureTooltipElement = null;
let measureTooltip = null;
let draw = null;
let typeMeasure = "length";
let measureSource = null;
let measureLayer = null;
let pointermoveListener = null;
let mouseoutListener = null;

function formatLength(line) {
    var length = getLength(line, { projection: "EPSG:4326" });
    var output;
    if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + " " + "公里";
    } else {
        output = Math.round(length * 100) / 100 + " " + "米";
    }
    return output;
}
function formatArea(polygon) {
    var area = getArea(polygon, { projection: "EPSG:4326" });
    var output;
    if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + " " + "平方公里";
    } else {
        output = Math.round(area * 100) / 100 + " " + "平方米";
    }
    return output;
}
function pointerMoveHandler(evt) {
    if (evt.dragging) {
        return;
    }
    var helpMsg = "请绘制要素";

    if (Measure.sketch) {
        var geom = Measure.sketch.getGeometry();
        if (geom instanceof Polygon) {
            helpMsg = "双击完成绘制";
        } else if (geom instanceof LineString) {
            helpMsg = "双击完成绘制";
        }
    }

    helpTooltipElement.innerHTML = helpMsg;
    helpTooltip.setPosition(evt.coordinate);
    helpTooltipElement.classList.remove("hidden");
}
function initMeasure() {
    if (measureLayer != null) {
        return;
    } else {
        measureSource = new VectorSource();
        measureLayer = new VectorLayer({
            source: measureSource,
            zIndex: 999,
            style: new Style({
                fill: new Fill({
                    color: "rgba(255, 255, 255, 0.4)"
                }),
                stroke: new Stroke({
                    color: "#ffcc33",
                    width: 2
                }),
                image: new CircleStyle({
                    radius: 7,
                    fill: new Fill({
                        color: "#ffcc33"
                    })
                })
            })
        });
        Measure.map.addLayer(measureLayer);
    }
}
function createHelpTooltip() {
    if (helpTooltipElement) {
        helpTooltipElement.parentNode.removeChild(helpTooltipElement);
    }
    helpTooltipElement = document.createElement("div");
    helpTooltipElement.className = "ol-tooltip hidden";
    helpTooltip = new Overlay({
        element: helpTooltipElement,
        offset: [15, 0],
        positioning: "center-left"
    });
    Measure.map.addOverlay(helpTooltip);
}
function createMeasureTooltip() {
    if (measureTooltipElement) {
        measureTooltipElement.parentNode.removeChild(
            measureTooltipElement
        );
    }
    measureTooltipElement = document.createElement("div");
    measureTooltipElement.className = "ol-tooltip ol-tooltip-measure";
    measureTooltip = new Overlay({
        element: measureTooltipElement,
        offset: [0, -15],
        positioning: "bottom-center"
    });
    Measure.map.addOverlay(measureTooltip);
}
function addMeasureInteraction() {
    if (draw != null) {
        Measure.map.removeInteraction(draw);
    }
    initMeasure();
    draw = new Draw({
        source: measureSource,
        type: typeMeasure,
        style: new Style({
            fill: new Fill({
                color: "#ffcc3328"
            }),
            stroke: new Stroke({
                color: "rgba(255, 0, 0, 1)",
                lineDash: [10, 10],
                width: 2
            }),
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: "rgba(255, 0, 255, 0.7)"
                }),
                fill: new Fill({
                    color: "rgba(255, 0, 255, 0.2)"
                })
            })
        })
    });

    Measure.map.addInteraction(draw);

    createMeasureTooltip();
    createHelpTooltip();

    let listener;

    draw.on("drawstart", function (evt) {
        Measure.sketch = evt.feature;
        var tooltipCoord = evt.coordinate;
        listener = Measure.sketch.getGeometry().on("change", function (evt) {
            var geom = evt.target;
            var output;
            if (geom instanceof Polygon) {
                output = formatArea(geom);
                tooltipCoord = geom.getInteriorPoint().getCoordinates();
            } else if (geom instanceof LineString) {
                output = formatLength(geom);
                tooltipCoord = geom.getLastCoordinate();
            }
            measureTooltipElement.innerHTML = output;
            measureTooltip.setPosition(tooltipCoord);
        });
    });

    draw.on("drawend", function () {
        measureTooltipElement.className = "ol-tooltip ol-tooltip-static";
        measureTooltip.setOffset([0, -7]);
        Measure.sketch = null;
        measureTooltipElement = null;
        createMeasureTooltip();
        unByKey(listener);
        finishMeasure();
    });
}
function finishMeasure() {
    // 一次只画一个
    if (draw != null) {
        Measure.map.removeInteraction(draw);
    }
    unByKey(pointermoveListener);
    unByKey(mouseoutListener);
}
function startMeasure(type) {
    typeMeasure = type;
    addMeasureInteraction();
    pointermoveListener = Measure.map.on(
        "pointermove",
        pointerMoveHandler
    );
    mouseoutListener = Measure.map
        .getViewport()
        .addEventListener("mouseout", function () {
            helpTooltipElement.classList.add("hidden");
        });
}
function clear() {
    // 清空
    if (measureLayer != null) {
        measureLayer.getSource().clear();
    }
}

let Measure = {
    map: null,
    startMeasure: startMeasure,
    clear: clear, 
};
export default Measure;